<div class="tab-content">
  <div class="form-group" [formGroup]="form">
    <div class="form-field" [class.missing-data]="isFieldMissing('label')">
      <label for="label">{{ "pages.insight.assets.column_label" | translate }}</label>
      <input nbInput id="label" type="text" formControlName="label" fullWidth placeholder="-" (blur)="onFieldSaveRequested()" (keydown.enter)="onFieldSaveRequested()" />
    </div>
    <div class="form-field" [class.missing-data]="isFieldMissing('quantity')">
      <label for="quantity">
        {{ "Quantity" | translate }}
        ({{ quantityUnitName }})
      </label>
      <input nbInput id="quantity" type="number" formControlName="quantity" fullWidth placeholder="0" (blur)="onFieldSaveRequested()" (keydown.enter)="onFieldSaveRequested()" />
    </div>
    @if (asset?.perimeters?.length) {
    <div class="form-field">
      <label>{{ "asset_form_drawer.synthese.perimeter" | translate }}</label>
      <span class="field-text">{{ getPerimeterDisplay() }}</span>
    </div>
    }
    <div class="form-field">
      <label for="label">{{ "asset_form_drawer.synthese.technical_nomenclature" | translate }}</label>
      @if (canChangeAssetType()) {
      <div class="asset-type-field display-with-link" (click)="openAssetTypeSelector()">
        <div>
        <span [class.empty]="!assetTypeHierarchy">{{ assetTypeHierarchy || "-" }}</span>
          <span class="right-chevron">
            <nb-icon icon="chevron-right-outline"></nb-icon>
          </span>
        </div>
      </div>
      } @else {
      <div class="asset-type-field disabled">
        <span [class.empty]="!assetTypeHierarchy">{{ assetTypeHierarchy || "-" }}</span>
      </div>
      }
    </div>
    @if (showUniformatCode) {
    <div class="form-field" [class.missing-data]="isFieldMissing('uniformat_code')">
      <label for="uniformat_code">{{ "asset_form_drawer.synthese.uniformat_code" | translate }}</label>
      <input nbInput id="uniformat_code" type="text" formControlName="uniformat_code" fullWidth placeholder="-" (blur)="onFieldSaveRequested()" (keydown.enter)="onFieldSaveRequested()" />
    </div>
    }
    @if (showBrand) {
    <div class="form-field">
      <label for="marque">{{ "asset_form_drawer.synthese.brand" | translate }}</label>
      <input nbInput id="marque" type="text" formControlName="brand" fullWidth placeholder="-" autocomplete="off" (blur)="onFieldSaveRequested()" (keydown.enter)="onFieldSaveRequested()" />
    </div>
    }
    @if (showModel) {
    <div class="form-field">
      <label for="modele">{{ "asset_form_drawer.synthese.model" | translate }}</label>
      <input nbInput id="modele" type="text" formControlName="model" fullWidth placeholder="-" autocomplete="off" (blur)="onFieldSaveRequested()" (keydown.enter)="onFieldSaveRequested()" />
    </div>
    }
    @if (showMaintenanceCode) {
    <div class="form-field" [class.missing-data]="isFieldMissing('maintenance_code')">
        <label for="maintenance_code">{{ "asset_form_drawer.synthese.maintenance_code" | translate }}</label>
        <input nbInput id="maintenance_code" type="text" formControlName="maintenance_code" fullWidth placeholder="-" autocomplete="off" (blur)="onFieldSaveRequested()" (keydown.enter)="onFieldSaveRequested()" />
    </div>
    }
    <div class="form-field photo-field">
      <label for="asset_photos">{{ "asset_form_drawer.synthese.photos" | translate }}</label>
      <input #photoFileInput type="file" accept="image/*" style="display: none" (change)="onPhotoFileSelected($event)" />
      <div class="photos-container" [class.photos-container--empty]="assetPictures.length === 0" (click)="assetPictures.length === 0 && openPhotoCarousel(0)">
        @if (assetPictures.length > 0) {
          @for (picture of assetPictures; track picture.id; let i = $index) {
            @if (failedPictureIds.has(picture.id)) {
              <div class="photo-img photo-img-error" (click)="openPhotoCarousel(i)">
                <i class="fa-thin fa-image"></i>
              </div>
            } @else {
              <img
                [src]="getThumbnailUrl(picture) || picture.picture"
                [alt]="asset.label"
                class="photo-img"
                (error)="onImageError($event, picture)"
                (click)="openPhotoCarousel(i)"
              />
            }
          }
          <button
            type="button"
            class="photo-add-btn"
            (click)="$event.stopPropagation(); triggerPhotoUpload()"
            [disabled]="isUploadingPhoto"
            title="{{ 'asset_form_drawer.synthese.add_photo' | translate }}"
          >
            <i class="fa-light fa-circle-plus"></i>
          </button>
        } @else {
          <span class="field-text">-</span>
        }
      </div>
    </div>
    <div class="form-field defauts-field">
      <label>{{ "asset_form_drawer.synthese.defauts" | translate }}</label>
      <div class="defauts-value">
        <span class="field-text">{{ asset?.defaults ?? '-' }}</span>
        @if (canGoToAudit) {
          <button class="audit-link-btn" (click)="goToAudit()" title="{{ 'asset_form_drawer.menu.open_audit' | translate }}">
            <fa-icon icon="mobile-notch"></fa-icon>
          </button>
        }
      </div>
    </div>
    <div class="form-field">
      <label for="zone_details">{{ "asset_form_drawer.synthese.zone_details" | translate }}</label>
      <input nbInput id="zone_details" type="text" formControlName="zone_details" fullWidth placeholder="-" (blur)="onFieldSaveRequested()" (keydown.enter)="onFieldSaveRequested()" />
    </div>
    <div class="form-field">
      <label for="comments">{{ "Comment" | translate }}</label>
      <textarea nbInput id="comments" type="text" formControlName="comments" fullWidth maxlength="512" placeholder="-" (blur)="onFieldSaveRequested()"></textarea>
    </div>
  </div>
</div>
